import React, { use } from 'react'
import { useRef } from 'react'
import { useEffect, useState } from 'react'

export default function CustomSelect({defaultValueForInput, options, many = false, callback, label, clear}) {
    const [selectedOption, setSelectedOption] = useState(defaultValueForInput || "")
    const [touched, setTouched] = useState(false)
    const [showPopUp, setShowPopUp] = useState(false)
    const ref = useRef()

    useEffect(() => {
        if(many){
            callback(selectedOption)
        }
    }, [selectedOption])

    useEffect(() => {
        if(!touched){
            setSelectedOption(defaultValueForInput)
        }
    }, [defaultValueForInput])

    useEffect(() => {
        if(clear){
            setSelectedOption("")
            setTouched(false)
        }
    }, [clear])



  return (
    <div style={{ position: "relative" }}>
        <p className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]" >{label}</p>
        <input ref={ref} style={{marginBottom: 0}} className='w-full border border-gray-500 rounded-md p-2' type="text" value={selectedOption} onChange={(e) => {setSelectedOption(e.target.value); callback(e.target.value)}} onFocus={() => {setShowPopUp(true); setTouched(true)}} onBlur={() => setShowPopUp(false)}/>
        {showPopUp && (
            <div className='z-10 bg-white border-2 border-gray-300 top-full rounded-md w-[calc(100%-40px)] mx-[20px] max-h-[300px] overflow-auto' style={{position: "absolute"}}>
               {options?.filter(el => !many ? el.props.children.toLowerCase().includes(selectedOption.trim().toLowerCase()): (() => {const arr = selectedOption.split(","); return el.props.children.toLowerCase().includes(arr[arr.length - 1].trim().toLowerCase())})()).map((option, i) => (
                    <div
                        key={i}
                        className='p-2 border-b border-gray-300 hover:bg-gray-100 cursor-pointer'
                        onMouseDown={() => {
                              if(many){
                                    const values = selectedOption.split(",")
                                    values[values.length - 1] = option.props.value + ", "
                                    setSelectedOption(values.join(","))
                                    ref.current.focus()
                                } else {
                                    setSelectedOption(option.props.children)
                                    callback(option.props.value)
                                }
                        }}
                    >
                        {option.props.children}
                    </div>
                    ))}

            </div>
        )}
    </div>
  )
}